import {
  BrithdayWrapper,
  Button,
  CellphoneWrapper,
  CPFWrapper,
  SelectWrapper,
  Textfield,
  UploadButton,
} from 'components/FormsUI';
import { LinearProgress } from 'components/LinearProgress';
import { FormMessage } from 'components/Message';
import { FormTitle } from 'components/Titles';
import { Typography } from 'components/Typography';
import { Form } from 'formik';
import { bond, gender, specialization, uf } from 'mocks';
import { FC } from 'react';

import { Box, CircularProgress, Grid, Paper } from '@mui/material';
import { CustomSwitch } from 'components/Switch';
import { useHistory } from 'react-router-dom';
import { VetService } from 'services';

interface IVetSignUpForm {
  data?: any;
  loading: boolean;
  success: string;
  error: string;
  update?: boolean;
}

export const VetSignUpForm: FC<IVetSignUpForm> = ({
  loading,
  error,
  success,
  data,
  update,
}: any) => {
  const history = useHistory();
  const handleGoBack = () => history.goBack();

  return (
    <Form encType="multipart/form-data">
      <Paper variant="outlined" sx={{ border: '2px solid #FBB45F' }}>
        {loading && <LinearProgress />}
        <Box p={2}>
          <Grid container spacing={6}>
            <Grid item xs={12} lg={6}>
              <Box pb={1}>
                <FormTitle title="DADOS PESSOAIS" />
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                  <Textfield
                    required
                    name="name"
                    id="name"
                    label="NOME COMPLETO"
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <BrithdayWrapper
                    name="birthday"
                    id="birthday"
                    label="DATA DE NASCIMENTO"
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  {update ? (
                    <CPFWrapper
                      name="cpf"
                      id="cpf"
                      label="CPF"
                      disabled={true}
                    />
                  ) : (
                    <CPFWrapper name="cpf" id="cpf" label="CPF" />
                  )}
                </Grid>
                <Grid item xs={12} lg={6}>
                  <SelectWrapper
                    name="gender"
                    id="gender"
                    label="GÊNERO"
                    options={gender}
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Textfield required name="email" id="email" label="EMAIL" />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <CellphoneWrapper name="phone" id="phone" label="CELULAR" />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="button"
                    sx={{ fontSize: 20, fontWeight: 500 }}
                  >
                    ANEXAR DOC. IDENTIFICAÇÃO
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <UploadButton
                    id="idDoc"
                    name="idDoc"
                    title={data?.idDoc?.name ?? 'ANEXAR DOC. IDENTIFICAÇÃO'}
                    url={VetService.getIdentificationDocument(data?._id)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Box pb={1}>
                <FormTitle title="DADOS PROFISSIONAIS" />
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                  <Textfield
                    required
                    name="crmv"
                    id="crmv"
                    label="CRMV"
                    type="number"
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <SelectWrapper
                    required
                    name="uf"
                    id="uf"
                    label="UF"
                    options={uf}
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <SelectWrapper
                    required
                    id="specialization"
                    name="specialization"
                    label="ESPECIALIZAÇÃO"
                    options={specialization}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="button"
                    sx={{ fontSize: 20, fontWeight: 500 }}
                  >
                    ANEXAR CARTÃO DO CONSELHO
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <UploadButton
                    id="counselorCard"
                    name="counselorCard"
                    title={
                      data?.counselorCard?.name ?? 'ANEXAR CARTÃO DO CONSELHO'
                    }
                    url={VetService.getCounselorCardDocument(data?._id)}
                  />
                </Grid>
                {update && (
                  <Box p={2} marginTop={2}>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={12} md={6}>
                        <SelectWrapper
                          name="bond"
                          label="VÍNCULO"
                          options={bond}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <CustomSwitch
                          name="active"
                          label={
                            data.active ? 'Conta ativada' : 'Conta desativada'
                          }
                          checked={data.active}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
        {error && (
          <Box p={1}>
            <Grid container justifyContent="flex-end">
              <Grid item xs={6}>
                <FormMessage data={error} severity="error" />
              </Grid>
            </Grid>
          </Box>
        )}
        {success && (
          <Box p={1}>
            <Grid container justifyContent="flex-end">
              <Grid item xs={6}>
                <FormMessage data={success} severity="success" />
              </Grid>
            </Grid>
          </Box>
        )}
      </Paper>
      <Box py={1}>
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Button onClick={handleGoBack}>voltar</Button>
          </Grid>
          <Grid item>
            <Button disabled={loading}>
              {update ? 'ATUALIZAR' : 'CADASTRAR'}

              {loading && (
                <CircularProgress
                  size="small"
                  sx={{ width: 24, height: 24, ml: 2 }}
                />
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Form>
  );
};
